var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiddingCosts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#CA2B2B",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6641 21.6665C19.4255 21.6665 21.6641 19.4279 21.6641 16.6665C21.6641 13.9051 19.4255 11.6665 16.6641 11.6665C13.9026 11.6665 11.6641 13.9051 11.6641 16.6665C11.6641 19.4279 13.9026 21.6665 16.6641 21.6665Z",
    stroke: "#CA2B2B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0755 18.6416C25.8633 18.9353 26.5643 19.4229 27.1136 20.0593C27.663 20.6957 28.0431 21.4603 28.2186 22.2825C28.3942 23.1047 28.3596 23.9579 28.1181 24.7631C27.8765 25.5684 27.4358 26.2998 26.8367 26.8896C26.2376 27.4794 25.4995 27.9087 24.6905 28.1376C23.8816 28.3666 23.0279 28.3879 22.2086 28.1995C21.3892 28.0111 20.6306 27.6192 20.0029 27.0599C19.3751 26.5007 18.8985 25.7922 18.6172 24.9999",
    stroke: "#CA2B2B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8359 15H16.6693V18.3333",
    stroke: "#CA2B2B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9229 21.5669L24.5062 22.1586L22.1562 24.5086",
    stroke: "#CA2B2B",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiddingCosts);
export default __webpack_public_path__ + "static/media/Bidding Costs.8d777243ca406f7879b7ab711a2a27c3.svg";
export { ForwardRef as ReactComponent };